import { render, staticRenderFns } from "./ConfirmarSaida.vue?vue&type=template&id=77d56d40&"
import script from "./ConfirmarSaida.vue?vue&type=script&lang=ts&"
export * from "./ConfirmarSaida.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports